import bundleState from './bundle';
import courseState from './course';
import courseEvaluationState from './courseEvaluation';
import eventState from './event';
import eventEvaluationState from './eventEvaluation';
import { cloneDeep } from 'lodash';

const startDate = new Date();
startDate.setHours(0, 0, 0, 0);

const endDate = new Date();
endDate.setMonth(endDate.getMonth() + 12);
endDate.setHours(23, 59, 59, 999);

const bundlesState = {
  url: '/bundles',
  stateName: 'Bundles',
  data: {
    specialClass: 'fixed-sidebar'
  },
  reloadOnSearch: false,
  views: {
    'a@app': {
      template: '<marketplace></marketplace>'
    }
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    refresh: /* @ngInject */ ResolveClass => {
      return ResolveClass.refreshLogin(false);
    }
  }
};

const vendorBundlesState = cloneDeep(bundlesState);
const vendorBundleState = cloneDeep(bundleState);

const eventsState = {
  url:
    '/events?author&category&courseAudience&credits&endTime&license&location&name&pageSize&sortType&startTime&subjectArea&tags&vendor&view',
  stateName: 'Webinars and Live Events',
  data: {
    specialClass: 'fixed-sidebar'
  },
  params: {
    category: {
      type: 'string',
      value: '',
      squash: true
    },
    license: {
      type: 'string',
      value: '',
      squash: true
    },
    startTime: {
      type: 'int',
      value: startDate.getTime(),
      squash: false
    },
    endTime: {
      type: 'int',
      value: endDate.getTime(),
      squash: false
    }
  },
  reloadOnSearch: false,
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/events'),
    refresh: /* @ngInject */ ResolveClass => {
      return ResolveClass.refreshLogin(false, 'user.events');
    }
  },
  views: {
    'a@app': {
      template: '<marketplace></marketplace>'
    }
  }
};

const coursesState = {
  url: '/courses?author&category&courseAudience&credits&license&name&pageSize&sortType&subjectArea&tags&vendor&view',
  stateName: 'Self Study',
  data: {
    specialClass: 'fixed-sidebar'
  },
  reloadOnSearch: false,
  resolve: {
    ResolveClass: 'ResolveClass',
    refresh: /* @ngInject */ ResolveClass => {
      return ResolveClass.refreshLogin(false, 'user.courses');
    },
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/courses'),
  },
  views: {
    'a@app': {
      template: '<marketplace></marketplace>'
    }
  }
};

const internalsState = {
  url:
    '/internal?author&category&courseAudience&credits&endTime&license&location&name&pageSize&sortType&startTime&subjectArea&tags&vendor&vendor_id&view',
  stateName: 'Internal Webinars & Live Courses',
  data: {
    specialClass: 'fixed-sidebar'
  },
  params: {
    category: {
      type: 'string',
      value: '',
      squash: true
    },
    license: {
      type: 'string',
      value: '',
      squash: true
    },
    startTime: {
      type: 'int',
      value: startDate.getTime(),
      squash: false
    },
    endTime: {
      type: 'int',
      value: endDate.getTime(),
      squash: false
    }
  },
  reloadOnSearch: false,
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/internal'),
    refresh: /* @ngInject */ ResolveClass => {
      return ResolveClass.refreshLogin(true, 'user.internal');
    }
  },
  views: {
    'a@app': {
      template: '<marketplace></marketplace>'
    }
  }
};

const internalsInternalState = cloneDeep(eventState);

const cpeCatalogState = {
  url:
    '/catalog?author&category&courseAudience&credits&deliveryMethod&endTime&license&location&name&pageSize&sortType&startTime&subjectArea&tags&vendor&view',
  stateName: 'Webinars and Live Events',
  data: {
    specialClass: 'fixed-sidebar'
  },
  params: {
    category: {
      type: 'string',
      value: '',
      squash: true
    },
    license: {
      type: 'string',
      value: '',
      squash: true
    },
    startTime: {
      type: 'int',
      value: startDate.getTime(),
      squash: false
    },
    endTime: {
      type: 'int',
      value: endDate.getTime(),
      squash: false
    }
  },
  reloadOnSearch: false,
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/catalog'),
    refresh: /* @ngInject */ ResolveClass => {
      return ResolveClass.refreshLogin(false, 'user.catalog');
    }
  },
  views: {
    'a@app': {
      template: '<cpe-catalog></cpe-catalog>'
    }
  }
};

const cpeCatalogCoursesState = {
  url: '/courses',
  abstract: true,
  stateName: 'Courses',
  data: {
    specialClass: 'fixed-sidebar'
  }
};

const cpeCatalogCoursesCourseState = cloneDeep(courseState);

const cpeCatalogEventsState = {
  url: '/events',
  abstract: true,
  stateName: 'Events',
  data: {
    specialClass: 'fixed-sidebar'
  }
};

const cpeCatalogEventsEventState = cloneDeep(eventState);

const vendorsState = {
  url: '/vendors',
  abstract: true,
  stateName: 'Vendors',
  data: {
    specialClass: 'fixed-sidebar'
  }
};

const vendorState = {
  url: '/:vendor_id',
  abstract: true,
  stateName: 'vendor',
  data: {
    specialClass: 'fixed-sidebar'
  }
};

const vendorCoursesState = cloneDeep(coursesState);
const vendorCoursesCourseState = cloneDeep(courseState);

const vendorEventsState = cloneDeep(eventsState);
const vendorEventsEventState = cloneDeep(eventState);

export {
  bundleState,
  bundlesState,
  eventsState,
  coursesState,
  internalsState,
  internalsInternalState,
  cpeCatalogState,
  cpeCatalogCoursesState,
  cpeCatalogCoursesCourseState,
  cpeCatalogEventsState,
  cpeCatalogEventsEventState,
  courseState,
  eventState,
  courseEvaluationState,
  eventEvaluationState,
  vendorsState,
  vendorState,
  vendorBundlesState,
  vendorBundleState,
  vendorCoursesState,
  vendorCoursesCourseState,
  vendorEventsState,
  vendorEventsEventState
};



// WEBPACK FOOTER //
// ./src/app/controllers/marketplace/index.js